import React from 'react';
import UpdateChangelog from './UpdateChangelog';

export default function Update() {
  return (
    <UpdateChangelog />
  );
}
